import React, { memo } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import LazyLoad from "react-lazyload";
import TooltipComponent from "../StudentDashboard/Tooltip/Tooltip";
import MdContentCopy from "../../constants/icons/Md/MdContentCopy";
import { openLinkInNewTab } from "../../pages/StudentPages/LiveClasses/utils";

const ShareModal = ({ open, onClose, title, message, shareLink }) => {
  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Link Copied");
    } catch (err) {
      console.error(err);
    }
  };

  const getShareUrl = (platform) => {
    const encodedLink = encodeURIComponent(shareLink);
    const encodedTitle = encodeURIComponent(message);

    switch (platform) {
      case "twitter":
        return `https://twitter.com/intent/tweet?url=${encodedLink}&text=${encodedTitle}`;
      case "facebook":
        return `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
      case "reddit":
        return `https://www.reddit.com/submit?url=${encodedLink}&title=${encodedTitle}`;
      case "whatsapp":
        return `https://api.whatsapp.com/send?text=${encodedTitle}%0A${encodedLink}`;
      default:
        return "#";
    }
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p style={{ color: "#888888", fontSize: "14px", fontWeight: 400 }}>
            {"Share the Link below:"}
          </p>
          <br />
          <div className="d-flex justify-content-evenly py-2">
            <LazyLoad>
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  openLinkInNewTab(getShareUrl("twitter"));
                }}
                src="/TwitterSvg.svg"
                alt="twitter-icon"
              />
            </LazyLoad>
            <LazyLoad>
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  openLinkInNewTab(getShareUrl("facebook"));
                }}
                src="/FacebookSvg.svg"
                alt="facebook-icon"
              />
            </LazyLoad>
            <LazyLoad>
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  openLinkInNewTab(getShareUrl("reddit"));
                }}
                src="/RedditSvg.svg"
                alt="reddit-icon"
              />
            </LazyLoad>
            <LazyLoad>
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  openLinkInNewTab(getShareUrl("whatsapp"));
                }}
                src="/WhatsappSvg.svg"
                alt="whatsapp-icon"
              />
            </LazyLoad>
          </div>

          <div
            className="d-flex justify-content-between p-2 my-2"
            style={{
              color: "#888888",
              fontSize: "14px",
              fontWeight: 400,
              border: "1px solid #8D9CA5",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            <TooltipComponent TooltipText={shareLink} direction="bottom">
              <span>
                {shareLink?.slice(0, 50)}
                ...
              </span>
            </TooltipComponent>
            <MdContentCopy
              onClick={() => {
                copyText(shareLink);
              }}
              className="pt-0.5"
              style={{ color: "black" }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(ShareModal);
